import { render, staticRenderFns } from "./EmployeesAboutToUpgrade.vue?vue&type=template&id=39db5411&scoped=true"
import script from "./EmployeesAboutToUpgrade.vue?vue&type=script&lang=js"
export * from "./EmployeesAboutToUpgrade.vue?vue&type=script&lang=js"
import style0 from "./EmployeesAboutToUpgrade.vue?vue&type=style&index=0&id=39db5411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db5411",
  null
  
)

export default component.exports